import { Link } from "@tanstack/react-location"
import diplomaMedalLocked from "assets/illustrations/diplomaMedalLocked.svg"
import diplomaRibbonLocked from "assets/illustrations/diplomaRibbonLocked.svg"
import { useTranslation } from "react-i18next"
import type { DiplomaPreviewProps } from "../types"

import s from "./styles.module.scss"

export const DiplomaPreviewLocked = ({
  productLink,
  productTitle,
  title,
}: Pick<DiplomaPreviewProps, "title" | "productTitle" | "productLink">) => {
  const { t } = useTranslation()

  return (
    <div className={s.diploma}>
      <div className={s.top}>
        <img
          className={s.medal}
          src={diplomaMedalLocked}
          alt="Locked diploma medal"
        />

        <div className={s.ribbon}>
          <div className={s.ribbon__text}>{title}</div>
          <img className={s.ribbon__img} src={diplomaRibbonLocked} alt="" />
        </div>
      </div>

      <div className={s.bottom}>
        <div className={s.bottom__text}>{t("diploma.COMPLETE_TO_CERTIFY")}</div>
        <div className={s.bottom__productTitle}>{productTitle}</div>
        <Link to={productLink} className={s.playLink}>
          {t("diploma.PLAY_PRODUCT")}
        </Link>
      </div>
    </div>
  )
}
